module.exports = __webpack_public_path__ + "static/media/paypal.db850f0f.png";